/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FilterWidgetViewState extends models.WidgetViewState {
    constructor() {
        super();
        this.setDiscriminator("FilterWidgetViewState");
    }

    getFixupPrototypeFunction() { return FilterWidgetViewState.fixupPrototype; }

    static newInstance(model: Partial<FilterWidgetViewState>): FilterWidgetViewState {
        let obj = Object.assign(new FilterWidgetViewState(), model);
        FilterWidgetViewState.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FilterWidgetViewState>): FilterWidgetViewState {
        if (!model) return null;
        return FilterWidgetViewState.newInstance(<FilterWidgetViewState> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FilterWidgetViewState) {
        if (!obj) return;

        models.FilterWidgetViewState.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FilterWidgetViewState): boolean {
        if (models.WidgetViewState.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, FilterWidgetViewState.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.context) {
            models.DataContext.fixupPrototype(this.context);
        }
    }

    context: models.DataContext;

}
